var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCaptcha === 'yandex')?_c('div',{ref:"container",staticClass:"smart-captcha",style:({ height: _vm.invisible ? '0px' : '100px' }),attrs:{"id":_vm.id,"data-test-id":"smart-captcha"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }